/**
 * Mock-mode flag (§ pack demo). True when the app booted with ?preview=1/?mock=1
 * (persisted by preview/mockApi). The pack station reads this to use mock
 * peripherals (manual/simulated scale, skip the real camera) and to badge the
 * session as local-only; the real Web-Serial scale / PrintNode / carrier / camera
 * adapters slot in behind the same flow when this is false.
 */
export function isMockMode(): boolean {
  try {
    return localStorage.getItem("cairn.preview") === "1";
  } catch {
    return false;
  }
}
